export default "__VITE_ASSET__wIZn4jp5__"